// The id of each form of the client application (SEP-293).
//
// This module holds no form bank. The wire contract imports it, and the web
// application loads the contract on its first page. Keep the banks in
// `client-application-forms.ts`, which re-exports these names.

/** The id of each form, in the order the firm lists the account types. */
export const CLIENT_APPLICATION_FORM_IDS = [
    'individual',
    'company_discretionary_advisory',
    'company_execution_only',
    'trust',
    'ssas',
    'sipp',
] as const;

/** The id of one form. */
export type ClientApplicationFormId = (typeof CLIENT_APPLICATION_FORM_IDS)[number];
